// Stubs for TypeORM decorators on the frontend
export const Entity = () => () => {};
export const PrimaryColumn = () => () => {};
export const PrimaryGeneratedColumn = () => () => {};
export const Column = () => () => {};
export const CreateDateColumn = () => () => {};
export const UpdateDateColumn = () => () => {};
export const DeleteDateColumn = () => () => {};
export const Index = () => () => {};
export const Unique = () => () => {};
export const ManyToOne = () => () => {};
export const OneToMany = () => () => {};
export const OneToOne = () => () => {};
export const ManyToMany = () => () => {};
export const JoinColumn = () => () => {};
export const JoinTable = () => () => {};
export const Repository = () => () => {};
export const EntityRepository = () => () => {};
export const InjectRepository = () => () => {};

// For classes
export class DataSource {
  constructor() {}
  async initialize() {}
  async destroy() {}
}

export default new Proxy(
  {},
  {
    get() {
      return () => () => {};
    },
  },
);
